import { type ReactNode } from 'react';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { PillsSummary } from '@pages/notification-components/components/RequestsCard/RequestsHeader/components/PillsSummary';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';

interface RequestsHeaderProps {
    requests: ComponentCreateRequestMapped[];
}

export function RequestsHeader({ requests }: RequestsHeaderProps): ReactNode {
    const approvedRequestsCounter = requests.filter(
        (request) =>
            request.statusCode === ComponentCreateRequestStatusCode.Approved,
    ).length;

    return (
        <div className="flex flex-column gap-2">
            <h1>
                {approvedRequestsCounter}/{requests.length}
            </h1>
            <div className="flex align-items-center justify-content-between">
                <strong>Request approved</strong>
                <PillsSummary requests={requests} />
            </div>
        </div>
    );
}
